import User, {
  UserSkeleton,
  Props,
  placeholderBackgrounds,
  getRandomBackground,
  ProfileAvatar,
} from './User';

export {
  UserSkeleton,
  placeholderBackgrounds,
  getRandomBackground,
  ProfileAvatar,
};
export type { Props };
export default User;
